var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7553 3.0292L13.9067 2.18397C13.7891 2.06687 13.6216 2 13.4458 2H10.5542C10.3784 2 10.2109 2.06687 10.0933 2.18397L9.24473 3.0292C9.04514 3.22799 9.032 3.52597 9.21345 3.73825L10.5149 5.26082C6.52851 5.95779 3.5 9.41111 3.5 13.5663C3.5 18.2241 7.30558 22 12 22C16.6944 22 20.5 18.2241 20.5 13.5663C20.5 9.41111 17.4715 5.95779 13.4851 5.26082L14.7866 3.73825C14.968 3.52597 14.9549 3.22799 14.7553 3.0292ZM4.95714 13.5663C4.95714 9.70693 8.11034 6.57831 12 6.57831C15.8897 6.57831 19.0429 9.70693 19.0429 13.5663C19.0429 17.4256 15.8897 20.5542 12 20.5542C8.11034 20.5542 4.95714 17.4256 4.95714 13.5663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing1);
export default __webpack_public_path__ + "static/media/ring-1.f0d87d0a32edcfa1aeee746a2b5d1147.svg";
export { ForwardRef as ReactComponent };